import { render, staticRenderFns } from "./ogMod.vue?vue&type=template&id=13b35d72&scoped=true"
import script from "./ogMod.vue?vue&type=script&lang=js"
export * from "./ogMod.vue?vue&type=script&lang=js"
import style0 from "./ogMod.vue?vue&type=style&index=0&id=13b35d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b35d72",
  null
  
)

export default component.exports